import { useCallback, useEffect, useRef, useState } from 'react'

export function useBootSequence(loading) {
  const [bootVisible, setBootVisible] = useState(true)
  const [bootExiting, setBootExiting] = useState(false)
  const [stageLive, setStageLive] = useState(false)
  const [bootTermVisible, setBootTermVisible] = useState(false)
  const [bootLineCount, setBootLineCount] = useState(0)
  const bootFinishedRef = useRef(false)

  const finishBoot = useCallback(() => {
    if (bootFinishedRef.current) return
    bootFinishedRef.current = true
    setBootExiting(true)
    setTimeout(() => {
      setBootVisible(false)
      setStageLive(true)
    }, 550)
  }, [])

  useEffect(() => {
    if (loading) return undefined

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    bootFinishedRef.current = false
    setBootVisible(true)
    setBootExiting(false)
    setStageLive(false)
    setBootTermVisible(false)
    setBootLineCount(0)

    const onSkip = (event) => {
      if (event.type === 'keydown' && !['Space', 'Escape'].includes(event.code)) return
      finishBoot()
    }

    window.addEventListener('keydown', onSkip)

    let termTimer
    if (reduce) {
      setBootTermVisible(true)
    } else {
      termTimer = setTimeout(() => setBootTermVisible(true), 820)
    }

    return () => {
      window.removeEventListener('keydown', onSkip)
      if (termTimer) clearTimeout(termTimer)
    }
  }, [loading, finishBoot])

  useEffect(() => {
    if (!bootTermVisible || bootFinishedRef.current) return undefined

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const lineInterval = 400
    const postLinePause = 900

    if (reduce) {
      setBootLineCount(6)
      const timer = setTimeout(finishBoot, 1200)
      return () => clearTimeout(timer)
    }

    const lineTimers = [0, lineInterval, lineInterval * 2, lineInterval * 3, lineInterval * 4, lineInterval * 5].map(
      (delay, index) => setTimeout(() => {
        if (!bootFinishedRef.current) setBootLineCount(index + 1)
      }, delay)
    )
    const finishTimer = setTimeout(() => {
      if (!bootFinishedRef.current) finishBoot()
    }, lineInterval * 5 + postLinePause)

    return () => {
      lineTimers.forEach((timer) => clearTimeout(timer))
      clearTimeout(finishTimer)
    }
  }, [bootTermVisible, finishBoot])

  return {
    bootVisible,
    bootExiting,
    stageLive,
    bootTermVisible,
    bootLineCount,
    finishBoot,
  }
}
